module.exports = __webpack_public_path__ + "img/delete.c802d192.svg";